//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserPublicAvatar from '@/components/users/UserPublicAvatar.vue'
import IconView from "@/components/objects/IconView.vue";
import get from 'lodash/get.js'
import { declensionOfNouns } from '@/utils/helpers.js'

export default {
  name: "Default",
  components: {
    IconView,
    UserPublicAvatar
  },
  props: {
    targetObject: {
      type: Object,
      default: () => ({})
    },
    polygonCounter: {
      type: Number,
      default: 0
    },
    small: {
      type: Boolean,
      default: false
    },
    ownerMode: {
      type: Boolean,
      default: false
    },
    shortName: {
      type: Boolean,
      default: false
    },
    showUserName: {
      default: false,
      type: Boolean
    },
    showStats: {
      type: Boolean,
      default: true
    },
    showHead: {
      type: Boolean,
      default: true
    },
    viewName: {
      type: String,
      default: 'objects-slug'
    },
    source: {
      type: String,
    },
    viewEditName: {
      type: String,
      default: 'objects_edit'
    },
    imagePath: {
      type: Array,
      default: () => {
        return ['/public/object_images_files/first_image/$id/?preview=1', 'id']
      }
    },
    showCategories: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showUserIcon: {
      type: Boolean,
      required: false,
      default: () => false
    },
    materialCategories: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      titleLinesCount: null
    }
  },
  computed: {
    firstBlock() {
      return Array.isArray(this.targetObject.blocks) && this.targetObject.blocks.length
        ? this.targetObject.blocks[0]
        : null
    },
    categoriesSliced() {
      const names = this.materialCategories.filter((category) => this.targetObject.categories_ids?.includes(category.id))
      return names.length > 1 ? names.slice(0, 3) : names
    },
    updatedAt() {
      const date = new Date(this.targetObject.updated_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    formattedCreatedAt() {
      const date = new Date(this.targetObject.created_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    createdFromToday() {
      const daysPast = (Date.parse(new Date().toDateString()) - Date.parse(new Date(this.targetObject.created_at).toDateString()))/(24 * 60 * 60 * 1000)
      if (daysPast === 0) {
        return `Сегодня`
      }
      if (daysPast === 1) {
        return `Вчера`
      }
      if (daysPast <= 7) {
        return `${daysPast} ${declensionOfNouns(daysPast, [
          "день",
          "дня",
          "дней",
        ])} назад`
      } else {
        return this.formattedCreatedAt
      }
    },
    createdAt() {
      return `Создано ${this.formattedCreatedAt}`
    },
    trimDescription() {
      return this.targetObject.text ? this.targetObject.text.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 140) : ''
    },
    resolvedImagePath() {
      const id = get(this.targetObject, this.imagePath[1])
      if (!id) return require(`~/assets/img/new-logo-full.png`)
      return this.$addServerPath(this.imagePath[0].replace('$id', id))
    },
  },
  mounted() {
    if (this.$refs.titleLink) {
      this.titleLinesCount = this.$refs.titleLink.getClientRects().length
    }
  }
}
